import * as React from "react";
import type { SVGProps } from "react";
export const SvgMiscMegaphone = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 18 18" {...props}>
    <path
      fill="currentColor"
      d="M15.75 7.547V3a.75.75 0 0 0-.75-.75h-.75c-1.484 1.484-4.273 2.315-6 2.71v8.08c1.727.395 4.516 1.226 6 2.71H15a.75.75 0 0 0 .75-.75v-4.547a1.5 1.5 0 0 0 0-2.906Zm-12-2.297a1.5 1.5 0 0 0-1.5 1.5v4.5a1.5 1.5 0 0 0 1.5 1.5h.75l.75 3.75h1.5V5.25h-3Z"
    />
  </svg>
);
